import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import SEO from "@/components/public/SEO";
import ArticleCard from "@/components/public/ArticleCard";
import { Search } from "lucide-react";

export default function SearchPage() {
  const [params, setParams] = useSearchParams();
  const initial = params.get("q") || "";
  const [q, setQ] = useState(initial);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!initial) return;
    (async () => {
      setLoading(true);
      try {
        const { data } = await api.get(`/search?q=${encodeURIComponent(initial)}&lang=tr`);
        setItems(data.items || []);
      } finally { setLoading(false); }
    })();
  }, [initial]);

  const submit = (e) => { e.preventDefault(); setParams({ q }); };

  return (
    <>
      <SEO title={initial ? `"${initial}" için arama` : "Arama"} description="Capella Cave Journal arşivinde arama yapın." noindex />
      <section className="pt-40 pb-16 max-w-3xl mx-auto px-6 md:px-10">
        <div className="text-[11px] tracking-overline uppercase text-cc-sepia mb-5">Arama</div>
        <h1 className="font-serif text-5xl md:text-7xl text-cc-text leading-none mb-10">Arşivde Ara</h1>
        <form onSubmit={submit} className="flex items-center gap-3 border-b border-cc-text pb-2" data-testid="search-form">
          <Search size={18} className="text-cc-text" />
          <input data-testid="search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Balon, vadi, restoran..." className="flex-1 bg-transparent outline-none text-cc-text" />
          <button data-testid="search-submit" className="cc-btn text-[10px] py-2 px-4">Ara</button>
        </form>
      </section>

      <section className="pb-32 max-w-7xl mx-auto px-6 md:px-10">
        {loading ? <p className="text-cc-muted">Yükleniyor…</p>
          : initial && items.length === 0 ? <p className="text-cc-muted">Sonuç bulunamadı.</p>
          : (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-16">
              {items.map((a, i) => <ArticleCard key={a.id} article={a} index={i} />)}
            </div>
          )}
      </section>
    </>
  );
}
